import {RepoListItem, RepoResult} from './repo-list-item';
import {RemixRepoListItem} from './remix-repo-list-item';
import {OfferListItem, OfferMeta} from './offer-list-item';

interface OfferMap {
  [position: number]: OfferMeta
}

type ListItem = { type: "repo"; data: RepoResult } | { type: "offer"; data: OfferMeta };

function augmentOfferLinks(repoResults: RepoResult[], offerMap?: OfferMap): ListItem[] {
  const listItems: ListItem[] = repoResults.map((r) => ({ type: "repo", data: r }));

  if(offerMap) { // add offer links if object is specified
    for (let [position, offerMeta] of Object.entries(offerMap) as [string, OfferMeta][]) {
      const positionNumber = Number(position);

      if(positionNumber < listItems.length) {
        // insert into list
        listItems.splice(positionNumber, 0, { type: "offer", data: offerMeta });
      }
    }
  }

  return listItems;
}

interface RepoListProps {
  repoResults: RepoResult[];
  offerMap?: OfferMap;
}

export function RemixRepoList({repoResults, offerMap}: RepoListProps) {
  const listItems = augmentOfferLinks(repoResults, offerMap);

  return <ul role="list" className="divide-y divide-gray-100" >
    {listItems.map((listItem, i) => (
      listItem.type === "repo"
        ? <RemixRepoListItem key={`repo-${i}`} repoResult={listItem.data} />
        : <OfferListItem key={`aff-${i}`} offerMeta={listItem.data} listPosition={i} />
    ))}
  </ul>
}
